import service from '@/utils/server';

const modName='/bd/qcSampling/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const exportData = data => {
  return service({
    url: modName + 'export',
    method: 'post',
    responseType: 'blob',
    data
  });
};

//质检结果重新导入开关
export const geQcResultReImport = data => {
  return service({
    url: modName + 'openReuploadSwitch',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/bd/qc/qcSampling/api/index.js